import { Button } from "@chakra-ui/button";
import { Box, Center, HStack, Link, Text } from "@chakra-ui/layout";
import Icon from "@modules/Icon";
import { Link as GatsbyLink } from "gatsby";
import React from "react";
import { Else, If, Then } from "react-if";
import useCalendlyModal from "../hooks/useCalendlyModal";
import { NeedHelpIconHero } from "../style";
import CalendlyButton from "./CalendlyButton";

interface IButtonItem {
  item: {
    icon: string;
    title: string;
    link: string;
    isExternal: boolean;
    type?: string;
  };
}

const needHelpData = [
  {
    icon: "needHelpSupport",
    title: "Request a Quote",
    link: "/request-a-quote/",
    isExternal: false,
  },
  {
    icon: "needHelpCheck",
    title: "Schedule a Demo",
    link: "/schedule-a-demo/",
    isExternal: false,
  },
  {
    icon: "phone",
    title: "Call us on 1 800 359-8561",
    link: "tel:1-800-359-8561",
    isExternal: true,
  },
  {
    icon: "tool",
    title: "Support Center",
    link: "https://support.commdevices.com/portal/en/signin",
    isExternal: true,
  },
];

const ButtonItem = ({ item }: IButtonItem) => {
  return (
    <Button borderWidth={0} borderColor={"transparent"}>
      <Center
        bg={"blue500"}
        width={"2.8125rem"}
        height={"2.8125rem"}
        borderRadius={"50%"}
      >
        <NeedHelpIconHero>
          <Icon name={item?.icon || "download"} />
        </NeedHelpIconHero>
      </Center>
      <Text color={"blue500"} ml={5} lineHeight={"1rem"}>
        {item?.title}
      </Text>
    </Button>
  );
};

const NeedHelp = () => {
  return (
    <Box bg={"white20"} p={7}>
      <Text textStyle={"h3"} mb={4}>
        Need Help?
      </Text>
      <Text>
        Need help or want to request a quote? Get in touch or visit our support
        center.
      </Text>

      {needHelpData.map((item, index) => (
        <HStack my={7} key={index}>
          <If condition={item.isExternal}>
            <Then>
              <Link href={item.link} isExternal target="_blank">
                <ButtonItem item={item} />
              </Link>
            </Then>
            <Else>
              <GatsbyLink to={item.link}>
                <ButtonItem item={item} />
              </GatsbyLink>
            </Else>
          </If>
        </HStack>
      ))}
    </Box>
  );
};

export default NeedHelp;
